import { useRef, useState, useEffect, RefObject } from "react";

interface ContainerSize {
  width: number;
  height: number;
}

export function useContainerSize(): [
  RefObject<HTMLDivElement | null>,
  ContainerSize,
] {
  const ref = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<ContainerSize>({ width: 0, height: 0 });

  useEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }
    const obs = new ResizeObserver(([entry]) => {
      const nextWidth = Math.floor(entry.contentRect.width);
      const nextHeight = Math.floor(entry.contentRect.height);
      setSize((prev) =>
        prev.width === nextWidth && prev.height === nextHeight
          ? prev
          : { width: nextWidth, height: nextHeight },
      );
    });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return [ref, size];
}
